const ALWAYS_REQUIRED_FIELDS = [
    'name',
    'address',
    'email',
    'taxIdType',
    'taxIdValue',
    'gstRegistered',
];
/**
 * Computes whether an organization has the minimum business/tax details (and, for
 * invoices, a default payment option) required to send a document or generate its PDF.
 * Deliberately narrower than the onboarding wizard's full completeness checklist — see
 * the "Invoice & Quote Readiness Gate" spec for the field list rationale.
 */
export function computeInvoicingReadiness(organization, documentType = 'invoice') {
    if (!organization) {
        const missingFields = [...ALWAYS_REQUIRED_FIELDS];
        if (documentType === 'invoice')
            missingFields.push('defaultPaymentOption');
        return { isReady: false, missingFields };
    }
    const missingFields = [];
    if (!organization.name)
        missingFields.push('name');
    if (!organization.address)
        missingFields.push('address');
    if (!organization.email)
        missingFields.push('email');
    if (!organization.taxIdType)
        missingFields.push('taxIdType');
    if (!organization.taxIdValue)
        missingFields.push('taxIdValue');
    if (organization.taxIdType === 'Other' && !organization.taxIdCustomLabel) {
        missingFields.push('taxIdCustomLabel');
    }
    if (organization.gstRegistered == null) {
        missingFields.push('gstRegistered');
    }
    else if (organization.gstRegistered) {
        if (!organization.defaultTaxType)
            missingFields.push('defaultTaxType');
        if (organization.defaultTaxRate == null)
            missingFields.push('defaultTaxRate');
    }
    if (documentType === 'invoice') {
        const hasDefaultPaymentOption = organization.paymentOptions?.some((option) => option.isDefault) ?? false;
        if (!hasDefaultPaymentOption)
            missingFields.push('defaultPaymentOption');
    }
    return { isReady: missingFields.length === 0, missingFields };
}
//# sourceMappingURL=organization-readiness.js.map